import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import projects from '../projects';

const Container = ({
    breakpoint,
    contactId,
    contactIsArchived,
    projectId,
    handleClickCreate,
    history,
}) => {
    useEffect(() => {
        if (projectId) {
            history.push(`/contacts/${contactId}/${projectId}`);
        }
    }, [projectId, history]);

    return (
        <projects.Container
            isArchived={contactIsArchived}
            breakpoint={breakpoint}
            contactId={contactId}
            handleClickCreate={handleClickCreate}
            onlyListView
        />
    );
};

Container.propTypes = {
    breakpoint: PropTypes.string,
    contactId: PropTypes.string,
    contactIsArchived: PropTypes.bool,
    handleClickCreate: PropTypes.func,
    history: PropTypes.object,
    projectId: PropTypes.string,
};

export default withRouter(Container);
